
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData'],
      ({ compData }) => {
        return {
          ...{"myProp":"world"},
          ...compData,
          
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  